<category-component></category-component>
<div class="main-product-listig">
    
     <img  *ngIf="promotionDetails?.top_banner && promotionDetails?.top_banner != ''" class="promotion-banner-new" src="{{promotionDetails?.top_banner}}" alt="banner">
    <button [ngClass]="promotionDetails?.top_banner == '' ? 'margin-without-banner' : ''" class="buy-get-free"><img class="px-2" src="../../../../assets/images/buy-get-free.svg" alt="">
        {{promotionDetails?.label}}</button>




    <div class="promotion-main">
        <div class="promotion-left">
            <div class="heading-product">
                <span class="produc-heading">Products</span> <span class="font-12">({{productListing?.length}})</span>
            </div>
            <div class="grid-prod" *ngIf="productListing?.length > 0 && componentLoaded">
                <div *ngFor="let product of productListing; let i = index" class="product-inner-wrapper">
                    <div class="product-image">
                        <span  *ngIf="product.price_marked == 1"><img
                            src="../../assets/images/pmp.svg" alt="checked icon" /></span>
                        <a href="javascript:void(0);">
                            <img src="{{imagePath}}{{product?.images[0]}}" (error)="onImageError($event)" alt="">
                        </a>

                        <div class="already-book-main" *ngIf="product?.showMsg">
                            <span class="already-book"
                                *ngIf="product.qty != '' && product.qty != 0 && product.back_in_stock != '0'"> Product
                                already in basket</span>
                        </div>
                    </div>
                    <div class="product-description" id="">
                        <a class="product-detail-name-bar" href="javascript:void(0);">
                            <h2 class="mb-0">{{product.short_desc}} </h2>
                            <p>({{product.unit_size}})</p>
                            <p>{{product.bar_code}} | {{product.sku}}</p>
                        </a>

                        <div class="d-flex mt-3">
                            <div class="col-md-8 p-0">
                                <div class="font-12">RSP</div>
                                <div class="d-flex">
                                    <div class="product-price text-dark" *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</div>
                                    <span class="font-14" *ngIf="product.rsp == '0.00'">N/A</span>
                                    <span class="each font-14"
                                        *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))">per
                                        100g</span>
                                    <span class="each font-14"
                                        *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)">Each</span>
                                </div>
                            </div>

                            <div *ngIf="global_data?.margin_visibility == 1" class="col-md-4 p-0">
                                <div class="font-12">Margin</div>
                                <div class="product-price text-dark">{{product.margin}}%</div>
                            </div>
                        </div>

                        <div class="d-flex mt-3">
                            
                            <div class="col-md-8 p-0" *ngIf="global_data?.price_visibility == 1">
                                <div class="font-12">Cost</div>
                                <div class="d-flex">
                                    <div class="product-price black text-dark">£{{product.price}}
                                    </div>
                                </div>

                            </div>

                            <div class="col-md-4 p-0">
                                <div class="font-12">Case</div>
                                <div class="product-price black text-dark">{{product.size_case}} </div>
                            </div>
                        </div>

                    </div>

                    <button class="cart-add"
                        [ngClass]="{'btn primary-btn':true, 'disabled':product.back_in_stock == '0' ?true : false }"
                        id="btn_{{product.product_id}}"
                        *ngIf="promotionDetails?.is_selection_product=='1' && product.item_id == '' && miniCartDetails.items_count != 0"
                        (click)="addToCart(product, product.qty, '', 'common', commonTemplate,commonTemplateFor24HrPopup,true)">Add</button>
                    <button class="cart-add"
                        [ngClass]="{'btn primary-btn':true, 'disabled':product.back_in_stock == '0' ?true : false, 'addfade': itemsPending == 0 ?true : false}"
                        id="btn_{{product.product_id}}"
                        *ngIf="promotionDetails?.is_selection_product=='1' && product.item_id == '' && miniCartDetails.items_count == 0"
                        (click)="addToCart(product, product.qty, addToCartTemplate, 'cart', commonTemplate,commonTemplateFor24HrPopup,true)">Add</button>
                    <button *ngIf="promotionDetails?.is_selection_product=='1' && product.back_in_stock == '0'"
                        class="product-cart-status out-of-stock-promotion"> Out of Stock
                    </button>
                    <div class="quantity " *ngIf="promotionDetails?.is_selection_product=='1' && product.item_id != ''">

                        <ngx-number-spinner id="spiner__btn_{{product.product_id}}"
                            [ngClass]="{'spinner':true, 'disabled':product.back_in_stock == '0' ?true : false, 'spinner-fade': itemsPending == 0 ?true : false}"
                            [value]="toInteger(product.qty)" [min]="0"
                            (change)="qytChange(product, $event, commonTemplate)">
                        </ngx-number-spinner>
                        <!-- [max]="itemsPending == 0 ? product.qty : undefined" -->

                    </div>
                    <div class="quantity " *ngIf="+promotionDetails?.is_selection_product==0 && promotionDetails?.is_promotion_applied == 1">
                        <ngx-number-spinner id="spiner__btn_{{product.product_id}}"
                            [ngClass]="{'disabled':true}"
                            [value]="toInteger(product.qty ? product.qty : 0)" [min]="0">
                        </ngx-number-spinner>
                    </div>
                </div>

            </div>

            
        </div>

        <div class="promotion-right" *ngIf="productListing?.length > 0 && componentLoaded">
            <div class="heading-product">
                <span class="produc-heading">Free <span *ngIf="freeProductListing?.length > 1 || freeProductListing?.length == 0">Products</span> <span *ngIf="freeProductListing?.length == 1">Product</span></span> <span class="font-12">({{ promotionDetails?.is_promotion_applied == 0 ? 0 : freeProductListing?.length }})</span>
            </div>
            <div class="right-inner-div">
                <p class=""  *ngIf="+promotionDetails?.is_selection_product==0">{{promotionDetails?.deal_text != null || promotionDetails?.deal_text != "" ? promotionDetails?.deal_text : ""}}</p>
                <p class="" *ngIf="+promotionDetails?.is_selection_product==1">Add {{itemsPending}} more product{{(itemsPending == 1 || itemsPending == 0) ? '': 's'}} to get the more free items</p>
                
                <div *ngIf="+promotionDetails?.is_selection_product == 1">
                    <rating [max]="promotionDetails?.promotion_apply_total_count" [(ngModel)]="promotionApplyCount"
                        [readonly]="isReadonly" [customTemplate]="tt"></rating>

                    <ng-template #tt let-i="index" let-v="value">
                        <button class="btn btn-{{i < v ? 'circle-green' : 'circle-normal'}}">
                            <span class="circle-span"></span> </button>
                    </ng-template>
                </div>

                <div class="free-promotion-product text-center" *ngIf="freeProductListing == null || freeProductListing?.length == 0">
                    <img src="../../../../assets/images/free-item.svg" alt="">
                </div>

                <div class="product-wrap-new-main" >

                <div class="product-new-wrapper" *ngFor="let product of freeProductListing; let i = index" [ngClass]="{ 'disabledproducts': promotionDetails?.is_promotion_applied == 0 }">
                    <div class="image-div">
                        <a href="javascript:void(0);">
                            <img alt="" src="{{imagePath}}{{product?.images[0]}}">
                        </a>
                    </div>
                    <div class="description-product">
                        <div class="title">
                            {{product.short_desc}}
                        </div>

                        <div class="small-des-main">
                        <div class="small-description">
                            <p>PC: <b>{{product.sku}}</b></p>
                            <p class="m-0" *ngIf="global_data?.price_visibility == 1">Cost:: <b>£{{product.price}}</b></p>
                        </div>
                        <div class="small-description">
                            <p class="m-0" *ngIf="product.rsp !== '0.00'">RSP: <b>£{{product.rsp}}</b></p>
                            <span class="font-14" *ngIf="product.rsp == '0.00'">RSP: N/A</span>
                            <span class="each font-14" *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))">per
                    100g</span>
                                <span class="each font-14" *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)">Each</span>
                            <p>Case: <b>{{product?.size_case ? product.size_case : '-'}}</b></p>
                        </div>

                        <div class="free-div">
                            <a class="free-button"> <span>{{product?.qty && product?.qty != "" ? toInteger(product.qty) : 0}}</span> free</a>
                        </div>
                    </div>
                    </div>
                </div>

                </div>

                <div class="right-div-left" *ngIf="+promotionDetails?.is_selection_product==0 && promotionDetails?.is_promotion_applied == 0">
                    <button class="last-div-button" (click)="addDeal(promotionDetails?.rule_id)">Add Deal</button>
                </div>

                <div class="bottom-bar-wrap free" *ngIf="+promotionDetails?.is_selection_product==1 && promotionDetails?.is_promotion_applied == 0">
                   <p class="deal-not-aplieed"> <img class="px-2" src="../../../../assets/images/shopping_cart_off.svg" alt="">Deal Not Added Yet</p>
                </div>

                <div class="bottom-bar-wrap deal-added " *ngIf="promotionDetails?.is_promotion_applied == 1">
                     
                    <div class="yellow-bar">
                    <img src="../../../../assets/images/buy-get-free.svg" alt="">    You have saved <b>£{{totalCost}} at Cost</b>  and <b>£{{totalRSP}} at RSP</b>
                    </div>

                    <div class="deal-div">
                        <button class=" col-md-4 p-0 last-div-button deal-applied">
                        <img width="20" class="deal-button-image" src="../../../../assets/images/deal.svg" alt="">
                        Deal Added 
                    </button>
                    <span *ngIf="+promotionDetails?.is_selection_product==1" class="badge-num">{{promotionDetails?.promotion_applied_count}}</span>
                    <ngx-number-spinner *ngIf="+promotionDetails?.is_selection_product==0" id="spinerbtn_{{promotionDetails.rule_id}}" class="spinner col-md-4 p-0" 
                    [value]="promotionDetails?.promotion_applied_count" [min]="0"
                        (change)="onChangePromotionCount(promotionDetails,$event,removeFreePdtTemplate,'spinnerbtn')">
                    </ngx-number-spinner>
                    <a class="delete-button" href="javascript:void(0);" (click)="onPromotionRemove(promotionDetails,removeFreePdtTemplate,'deletebtn')">
                        <img src="../../../../assets/images/delete.svg" alt="">
                        </a>
                    </div>
                 
                </div>
        </div>
    </div>
    
</div>

<div class="no-listing" *ngIf="!componentLoaded">
    <div class="col-12">
        <div class="no-result-content text-center text-dark">
            <img src="../../assets/images/hourglass-shb.svg" alt="no-result">
            <p>Loading...</p>
        </div>
    </div>
</div>
<!-- 
<div class="last-div">
    <div class="free-promotion-product text-center" *ngIf="itemsPending > 0 && freeProductListing.length == 0">
        <img src="../../../../assets/images/not_free_product.svg" alt="">
    </div>
    <div class="free-promotion-product" *ngIf="itemsPending == 0 && freeProductListing.length > 0">
        <div class="d-flex align-items-center">
            <div class="free-pro-heading">Free Items</div> <span class="free-count"></span>
        </div>

        <div class="grid-prod mt-4">
            <div class="product-inner-wrapper" *ngFor="let product of freeProductListing; let i = index">
                <div class="product-image">
                    <span *ngIf="product.price_marked == 1" class="PMP">PMP</span>
                    <a href="javascript:void(0);">
                        <img alt="" src="{{imagePath}}{{product?.images[0]}}">
                    </a>

                </div>
                <div class="product-description" id="">
                    <a class="product-detail-name-bar" href="javascript:void(0);">
                        <h2 class="mb-0">{{product.short_desc}} </h2>
                        <p>({{product.unit_size}})</p>
                        <p>{{product.bar_code}} | {{product.sku}}</p>
                    </a>

                    <div class="d-flex mt-3">
                        <div class="col-md-8 p-0">
                            <div class="font-12">RSP</div>
                            <div class="d-flex">
                                <div class="product-price text-dark" *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</div>
                                <span class="font-14" *ngIf="product.rsp == '0.00'">N/A</span>
                                <span class="each font-14"
                                    *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))">per
                                    100g</span>
                                <span class="each font-14"
                                    *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)">each</span>
                            </div>
                        </div>

                        <div *ngIf="global_data?.margin_visibility == 1" class="col-md-4 p-0">
                            <div class="font-12">Margin</div>
                            <div class="product-price text-dark">{{product.margin}}%</div>
                        </div>
                    </div>

                    <button class="free-button-product"><span
                            class="free-count-cart">{{product.is_free_product}}</span><img
                            src="../../../../assets/images/free-button.svg" alt=""></button>

                </div>
            </div>
        </div>
    </div>


    <div class="deal-last-div">
        <div class="last-div-left">
            <div *ngIf="promotionDetails?.is_selection_product == '1'">
                <h3 *ngIf="itemsPending > 0">{{itemsPending}} More item Required</h3>
                <h3 *ngIf="itemsPending == 0 && freeProductListing.length > 1">The free products are now yours</h3>
                <h3 *ngIf="itemsPending == 0 && freeProductListing.length == 1">
                    {{freeProductListing[0].short_desc}}...is now yours.</h3>

                <div>
                    <rating [max]="promotionDetails?.promotion_apply_total_count" [(ngModel)]="promotionApplyCount"
                        [readonly]="isReadonly" [customTemplate]="tt"></rating>

                    <ng-template #tt let-i="index" let-v="value">
                        <button class="btn btn-{{i < v ? 'circle-green' : 'circle-normal'}}">
                            <span class="circle-span"></span> </button>
                    </ng-template>
                </div>


            </div>
        </div>

        <div class="right-div-left" *ngIf="promotionDetails?.is_selection_product == '0'">
            <button class="last-div-button"
                *ngIf="promotionDetails?.is_selection_product=='0' && promotionDetails?.is_promotion_applied == 0"
                (click)="addDeal(promotionDetails?.rule_id)">Add Deal</button>
            <button class="last-div-button deal-applied "
                *ngIf="promotionDetails?.is_selection_product=='0' && promotionDetails?.is_promotion_applied == 1">
                <img class="deal-button-image" src="../../../../assets/images/deal.svg" alt="">
                Deal Added</button>

        </div>
    </div>
</div> -->
<ng-template #addToCartTemplate>
    <div class="modal-header border-0 pb-2 align-items-center flex-column">
        <h4 class="modal-title">Info</h4>
        <p>You are about to create a order for</p>
        <h4 class="modal-title">{{selectedStore.selectedStoreName}}</h4>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>Please change the store if you want to create an order for another store.</p>
                </div>
                <div class="button-success text-center mt-3">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">Ok</button>

                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #commonTemplate>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>{{popupMessage}} </p>
                </div>
                <div class="button-div text-center mt-3 align-items-center">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">{{commonBottonText}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #commonTemplateFor24HrPopup>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p style="white-space: pre-wrap">{{popupMessage}} </p>
                </div>
                <div class="button-div text-center mt-3 align-items-center">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">Cancel</button>
                    <button class="common-button mr-3"
                        (click)="addToCart(product_for_24_hr, product_for_24_hr.qty, addToCartTemplate, 'cart', commonTemplate,commonTemplateFor24HrPopup,false)">{{commonBottonText}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #removeFreePdtTemplate>
    <div class="modal-header border-0 pb-2">
        <h4 class="modal-title">Remove Deal</h4>
        <button type="button" class="close  " aria-label="Close" (click)="onPromotionRemovalCancel(modalService.config.initialState.type)">
        <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fill-rule="evenodd">
              <g stroke="#9B9B9B" stroke-width="1.75">
                <g>
                  <g>
                    <path d="M14 0L0 14M0 0L14 14"
                      transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                  </g>
                </g>
              </g>
            </g>
          </svg></span>
      </button>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>Entire deal ( all products quantites ) will be removed.<br/> Are you sure you want to proceed?</p>
                </div>
                <div class="button-div text-center mt-3">
                    <button class="common-button mr-3" (click)="onPromotionRemovalCancel(modalService.config.initialState.type)">Cancel</button>
                    <button class="common-button ghost" (click)="removeDeal(modalService.config.initialState.rule_id,modalService.config.initialState.removefullDeal,modalService.config.initialState.type == 'spinnerbtn' ? 1 : promotionDetails.promotion_applied_count)">Yes, Remove</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>